import { optionLabel } from '../utils';

interface FilterSelectProps {
  label: string;
  value: string;
  options: string[];
  onChange: (value: string) => void;
}

export function FilterSelect({ label, value, options, onChange }: FilterSelectProps) {
  return (
    <div className="control">
      <label>{label}</label>
      <select value={value} onChange={event => onChange(event.target.value)}>
        <option value="">Tất cả</option>
        {options.map(option => <option key={option} value={option}>{optionLabel(option)}</option>)}
      </select>
    </div>
  );
}
